<script setup lang="ts">
import BaseLazyImage from "@/components/LazyImage.vue";
import { AiImage } from "@/services/fobizzToolsApi";

const props = defineProps<{ image: AiImage; selected: boolean }>();
const truncatedTitle = computed(() =>
  props.image.prompt.split(" ").slice(0, 3).join(" ")
);
</script>
<template>
  <div class="image" :class="{ selected: selected }">
    <BaseLazyImage
      v-if="image.file"
      :src="image.file.previewUrl || image.file.url"
      :width="image.width"
      :height="image.height"
    />
    <div class="image-meta">
      {{ truncatedTitle }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.image {
  position: relative;
  background-color: $border-color;
  aspect-ratio: 1;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: $border-radius;
  }

  &::after {
    content: "";
    display: flex;
    position: absolute;
    inset: -4px;
    border: 2px solid $primary;
    border-radius: $border-radius-lg;
    opacity: 0;
    transition: opacity 0.2s ease-in;
  }

  &:hover,
  &:focus,
  &:focus-visible {
    border-color: $border-color;

    &::after {
      opacity: 1;
    }
  }

  &.selected {
    &::after {
      opacity: 1;
    }
  }
}

.image-meta {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: $spacer-1;
  font-size: 0.7rem;
  color: $white;
  background-color: $black;
  opacity: 0;
  transition: opacity 0.2s ease-in;
}

.selected .image-meta,
.image:hover .image-meta {
  opacity: 0.75;
}
</style>
